import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-doc-wise',
  templateUrl: './doc-wise.component.html',
  styleUrls: ['./doc-wise.component.scss']
})
export class DocWiseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
